import styled from 'styled-components';

export const GameIconWrapperDefaultBox = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    @media ${({theme}) => theme.mediaQuery.xs} {
        padding-left: 15px;
        width: 80%;
    }
`;